import Model, { attr, belongsTo, type AsyncBelongsTo } from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';
import type InitiativeModel from './initiative';
import type OrganisationModel from './organisation';
import type TeamModel from './team';

export default class BookmarkModel extends Model {
  declare [Type]: 'bookmark';
  @attr('string') declare title: string;
  @attr('string') declare url: string;
  @attr('string') declare icon: string;
  @belongsTo('team', { async: true, inverse: 'bookmarks' })
  declare team: AsyncBelongsTo<TeamModel>;
  @belongsTo('organisation', { async: true, inverse: 'bookmarks' })
  declare organisation: AsyncBelongsTo<OrganisationModel>;
  @belongsTo('initiative', { async: true, inverse: 'bookmarks' })
  declare initiative: AsyncBelongsTo<InitiativeModel>;
}
